import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from '../../../environments/environment';
import { skipLoading } from '../interceptors/skip-loading.context';

export interface DomActual {
  dom: string;
}

interface DomResponse {
  success: boolean;
  data: DomActual;
}

@Injectable({ providedIn: 'root' })
export class DomService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  actual(): Observable<DomActual> {
    return this.http
      .get<DomResponse>(`${this.apiUrl}/dom`, { context: skipLoading() })
      .pipe(map((response) => response.data));
  }
}
